import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './i18n'
import { routes } from './routes'
import { PageLoading } from './components/PageLoading'
import { processQueue, getPendingCount, ensureBackgroundSync } from './lib/offlineQueue'
import { isNative, onAppVisible } from './lib/platform'
import { initializeAppearance } from './lib/theme'

initializeAppearance()
const router = createBrowserRouter(routes, { future: { v7_relativeSplatPath: true } })
const queryClient = new QueryClient()
window.addEventListener('online', () => { void processQueue().catch(() => {}) })
if (!isNative() && 'serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', event => {
    if ((event.data as { type?: string } | undefined)?.type === 'POD_SYNC') void processQueue().catch(() => {})
  })
}
void getPendingCount().then(count => { if (count > 0) return ensureBackgroundSync() }).catch(() => {})
onAppVisible(() => { void processQueue().catch(() => {}) })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}><RouterProvider router={router} future={{ v7_startTransition: true }} fallbackElement={<PageLoading fullScreen delay={0} />} /></QueryClientProvider>
  </React.StrictMode>,
)
